import type { ModeCard as ModeDefinition } from './modeCards';
import { buildModeTargetUrl, navigateMode } from './navigation';

const ART: Record<string, string> = {
  '/adventure': '/icons/abilities/aimed_shot.svg',
  '/intro': '/icons/abilities/word_of_shielding.svg',
  '/resume': '/icons/abilities/healing_touch.svg',
};

export function ModeCard({ mode, onNavigate, primary = false }: {
  mode: ModeDefinition; onNavigate?: (target: string) => void; primary?: boolean;
}) {
  return <button type="button" className={`home-entry__card ${primary ? 'home-entry__card--primary' : ''}`}
    data-testid={`home-mode-card-${mode.id ?? mode.path.slice(1)}`}
    onClick={() => { if (onNavigate) onNavigate(buildModeTargetUrl(mode.path)); else navigateMode(mode.path); }}>
    <span className="home-entry__icon" aria-hidden="true">
      {ART[mode.path] ? <img src={ART[mode.path]} alt="" /> : mode.emoji}
    </span>
    <span className="home-entry__card-copy">
      <strong>{mode.label}</strong>
      <span>{mode.description}</span>
    </span>
    {primary && <span className="home-entry__card-action" aria-hidden="true">{mode.path === '/intro' ? 'Create a hero' : mode.path === '/resume' ? 'Return to your heroes' : 'Enter the adventure'} <span>→</span></span>}
  </button>;
}
